import { getRoute } from "@utils/route";

export const TERMS_AND_CONDITIONS_PAGE_URL = '/terms-and-conditions';

export const routeTermsAndConditionsPage = () => getRoute(TERMS_AND_CONDITIONS_PAGE_URL);
